export default __webpack_public_path__ + "static/promovarea-nutritiei-c8d193685f2adba7e4cabe587257112c.jpg";